import { useNotificationsButton } from '@framework/common-web/ui/notification/hook/useNotificationsButton.ts';
import { NotificationsDrawer } from '@framework/common-web/ui/notification/NotificationsDrawer.tsx';
import { IconMenuBadge } from '@framework/ui/components/badge/IconMenuBadge.tsx';
import { TopMenuIconButton } from '@framework/ui/components/button/TopMenuIconButton.tsx';
import { useTranslation } from 'react-i18next';
import { MdNotifications } from 'react-icons/md';
import { useTheme } from 'styled-components';

export function NotificationsButton() {
  const { t } = useTranslation();
  const theme = useTheme();
  const { unreadTotal, handleOpen, drawerProps } = useNotificationsButton();

  return (
    <>
      <TopMenuIconButton
        theme={theme.darkFrontofficeHeaderFlag ? 'negative' : 'positive'}
        aria-controls="notifications-drawer"
        aria-expanded={drawerProps.visible}
        aria-label={t(
          'layout.header.pulsante-notifiche',
          '{{count}} notifiche da leggere',
          { count: unreadTotal },
        )}
        aria-live="polite"
        aria-atomic="true"
        icon={
          <IconMenuBadge count={unreadTotal}>
            <MdNotifications
              aria-label={t(
                'notification-drawer.button.badge',
                'Notifiche da leggere',
              )}
              size={22}
            />
          </IconMenuBadge>
        }
        onClick={handleOpen}
      />
      <NotificationsDrawer {...drawerProps} />
    </>
  );
}
